import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';

// provider imports
import { providerSearchStateVM } from '../provider_list_view_models';
import { PROVIDER_LIST_FORM_KEY } from '../../provider_const';
import { providerSearchFormAtom } from '../provider_list_atoms';
import { useProviderListStore } from '../../list/pagehooks/useProviderListStore';
import { AdminProviderSearchModel } from '../provider_list_types';

const useProviderSearchInit = (): boolean => {
    const [init, setInit] = useState(true);
    const { action, ceOptions, getList } = useProviderListStore();
    const setSearchForm = useSetImmerAtom(providerSearchFormAtom);

    useEffect(() => {
        if (init && action == 'QUERY') {
            const vs = viewStateRepo.getForm(PROVIDER_LIST_FORM_KEY);
            const formState = providerSearchStateVM(vs as AdminProviderSearchModel, ceOptions);
            setSearchForm(() => formState);

            // immediate search if viewstate present
            if (vs) {
                getList(formState);
            }
            setInit(false);
        }
    }, [init, action, ceOptions, getList, setSearchForm]);

    return init;
};

export default useProviderSearchInit;
